// material ui theming

import getMuiTheme from 'material-ui/styles/getMuiTheme';

import { fade } from 'material-ui/utils/colorManipulator';
import site from '../config';

const base = {
  colorBase: '#3e3b41',
  colorBase2: '#707070',
  colorBase3: '#BBBBBB',
  colorError: '#a13434',
  colorBorderForm: '#cccccc'
};

const themeSeries = {
  FleetPartners: {
    colorPrimary: '#B9B309',
    colorSecondary: '#00457C'
  },
  FleetPlus: {
    colorPrimary: '#9ECD65',
    colorSecondary: '#77BA1F'
  },
  FleetSmart: {
    colorPrimary: '#7ebf4c',
    colorSecondary: '#442b6a'
  }
};

const theme = themeSeries[site];

export const colorPalette = theme;
export const muiTheme = getMuiTheme({
  fontFamily: 'noto-sans-regular',
  datePicker: {
    selectColor: theme.colorSecondary,
    color: theme.colorSecondary
  },
  textField: {
    disabledTextColor: base.colorBase,
    errorColor: base.colorError,
    focusColor: theme.colorSecondary,
    borderColor: base.colorBorderForm
  },
  checkbox: {
    boxColor: base.colorBase,
    checkedColor: theme.colorSecondary,
    labelColor: base.colorBase
  },
  radioButton: {
    borderColor: base.colorBase,
    checkedColor: theme.colorSecondary,
    labelColor: base.colorBase
  },
  flatButton: {
    textColor: base.colorBase,
    primaryTextColor: theme.colorPrimary
  },
  tabs: {
    backgroundColor: '#ffffff',
    textColor: base.colorBase,
    selectedTextColor: theme.colorSecondary
  },
  inkBar: {
    backgroundColor: theme.colorSecondary,
    size: 1
  },
  ripple: {
    color: '#ffffff'
  },
  stepper: {
    iconColor: theme.colorSecondary
  },
  timePicker: {
    color: theme.colorSecondary,
    accentColor: theme.colorSecondary,
    headerColor: theme.colorSecondary,
    selectColor: theme.colorSecondary
  },
  toggle: {
    thumbOnColor: theme.colorSecondary,
    thumbOffColor: base.colorBase3,
    // thumbDisabledColor: palette.borderColor,
    // thumbRequiredColor: palette.primary1Color,
    trackOnColor: fade(theme.colorSecondary, 0.5),
    trackOffColor: fade(base.colorBase3, 0.5),
    // trackDisabledColor: palette.primary3Color,
    labelColor: base.colorBase3,
    labelDisabledColor: base.colorBase3
  }
});



// WEBPACK FOOTER //
// ./src/themes/theme-material-ui.js